import React, { Component } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { toastr } from "react-redux-toastr";
import { FiPlus } from "react-icons/fi";
import { Nav } from "react-bootstrap";
import moment from "moment";
import { DateRangePicker } from "react-dates";
import "react-dates/lib/css/_datepicker.css";
import "react-dates/initialize";
import Loading from "components/Loading";
import Layout from "components/Layout";
import Modal from "components/Modal";
import EmployeeSelectSearch from "components/EmployeeSelectSearch/EmployeeSelectSearch";
import InfiniteScroll from "react-infinite-scroll-component";
import { showModal, hideModal } from "actions/modalActions";
import {
	exchangeStatus,
	planAssignmentExchangesService,
} from "services/planAssignmentExchangesService";
import ShiftExchangesList from "components/ShiftExchanges/ShiftExchangesList";
import ShiftExchangeCreateModal from "components/ShiftExchanges/ShiftExchangeCreateModal";
import { errorFormating, isAdmin, isSupervisor } from "utils/utils";

class ShiftExchanges extends Component {
	constructor(props) {
		super(props);
		const tabFromUrl = new URLSearchParams(props.location?.search).get("tab");
		const activeTab = tabFromUrl === "sent" ? "sent" : "received";

		this.state = {
			employee_id: -1,
			selectedEmployee: null,
			start_from: null,
			start_to: null,
			focusedInput: null,
			activeTab,
			isLoading: false,
			page: 0,
			page_size: 20,
			exchanges: [],
			hasMore: true,
		};
		this.exchangesRequestId = 0;

		this.closeModal = this.closeModal.bind(this);
		this.openAlertModal = this.openAlertModal.bind(this);
		this.openNewExchangeModal = this.openNewExchangeModal.bind(this);
		this.openEditExchangeModal = this.openEditExchangeModal.bind(this);
		this.getExchanges = this.getExchanges.bind(this);
	}

	componentDidMount() {
		this.getExchanges();
	}

	componentDidUpdate(prevProps) {
		if (!prevProps.user?.id && this.props.user?.id) {
			this.reloadExchanges();
		}
	}

	handleEmployeeChange = (id, employee) => {
		this.setState(
			{
				employee_id: id || this.props.user?.id || -1,
				selectedEmployee: employee || this.props.user || null,
				page: 0,
				exchanges: [],
				hasMore: true,
			},
			() => this.getExchanges()
		);
	};

	handleDatesChange = ({ startDate, endDate }) => {
		this.setState(
			{
				start_from: startDate ? startDate.format("YYYY-MM-DD") : null,
				start_to: endDate ? endDate.format("YYYY-MM-DD") : null,
				page: 0,
				exchanges: [],
				hasMore: true,
			},
			this.getExchanges
		);
	};

	handleTabSelect = (activeTab) => {
		const query = new URLSearchParams(this.props.location?.search);
		query.set("tab", activeTab);
		this.props.history.replace({
			pathname: this.props.location?.pathname,
			search: `?${query.toString()}`,
		});
		this.setState(
			{
				activeTab,
				page: 0,
				exchanges: [],
				hasMore: true,
			},
			() => this.getExchanges()
		);
	};

	async getExchanges() {
		const {
			employee_id,
			activeTab,
			page,
			page_size,
			exchanges,
			start_from,
			start_to,
		} = this.state;
		const { user } = this.props;
		const canSeeAll = isAdmin() || isSupervisor();
		const userId = user?.id;
		const selectedEmployeeId = Number(employee_id) > 0 ? employee_id : userId;
		const requestId = ++this.exchangesRequestId;

		this.setState({ isLoading: page === 0 });

		if (!selectedEmployeeId) {
			this.setState({ exchanges: [], isLoading: false, hasMore: false });
			return;
		}

		try {
			const response = await planAssignmentExchangesService.getAll({
				requester_employee_id:
					activeTab === "sent" ? selectedEmployeeId : undefined,
				target_employee_id:
					activeTab === "received" ? selectedEmployeeId : undefined,
				start_from,
				start_to,
				page,
				page_size,
			});

			if (requestId !== this.exchangesRequestId) return;

			let newItems = [];
			let totalItems = 0;

			if (response.data) {
				newItems = response.data;
				if (response.pagination?.total_items) {
					totalItems = response.pagination.total_items;
				} else if (response.total) {
					totalItems = response.total;
				}
			} else if (Array.isArray(response)) {
				newItems = response;
			}

			newItems = newItems.filter((exchange) => {
				const participant =
					activeTab === "sent"
						? exchange.requester_employee
						: exchange.target_employee;
				return String(participant?.id) === String(selectedEmployeeId);
			});

			const allItems = page === 0 ? newItems : exchanges.concat(newItems);

			let hasMore = false;
			if (canSeeAll && newItems.length > 0) {
				hasMore =
					totalItems > 0
						? allItems.length < totalItems
						: newItems.length === page_size;
			}

			this.setState({ exchanges: allItems, isLoading: false, hasMore });
		} catch (error) {
			if (requestId !== this.exchangesRequestId) return;
			console.error("Error fetching shift exchanges:", error);
			this.setState({ isLoading: false, hasMore: false });
		}
	}

	fetchMoreData = () => {
		this.setState({ page: this.state.page + 1 }, () => this.getExchanges());
	};

	reloadExchanges = () => {
		this.setState({ page: 0, exchanges: [], hasMore: true }, () =>
			this.getExchanges()
		);
	};

	closeModal() {
		this.props.hideModal();
	}

	openNewExchangeModal() {
		const { t } = this.props;
		this.props.showModal(
			{
				open: true,
				title: t("shiftExchanges.newRequest"),
				style: { width: "680px" },
				content: (
					<ShiftExchangeCreateModal
						handleClose={this.closeModal}
						reloadExchanges={this.reloadExchanges}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openEditExchangeModal(exchange) {
		const { t } = this.props;
		this.props.showModal(
			{
				open: true,
				title: t("shiftExchanges.editRequest"),
				style: { width: "680px" },
				content: (
					<ShiftExchangeCreateModal
						exchange={exchange}
						handleClose={this.closeModal}
						reloadExchanges={this.reloadExchanges}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	cancelOwnExchange = (exchange) => {
		this.props.showModal(
			{
				open: true,
				title: this.props.t("shiftExchanges.cancelRequest"),
				style: { width: "400px" },
				message: this.props.t("shiftExchanges.cancelRequestConfirm"),
				confirmText: this.props.t("shiftExchanges.cancelRequest"),
				confirmAction: async () => {
					const response = await planAssignmentExchangesService.update({
						...exchange,
						status: exchangeStatus.canceled,
						requester_plan_id:
							exchange.requester_plan?.assignments?.[0]?.id ||
							exchange.requester_plan_id,
						target_plan_id:
							exchange.target_plan?.assignments?.[0]?.id ||
							exchange.target_plan_id,
					});

					if (response.ok) {
						this.closeModal();
						toastr.success(
							this.props.t("common.success"),
							this.props.t("common.changesSaved")
						);
						this.reloadExchanges();
						return;
					}

					const error = errorFormating(response);
					this.closeModal();
					this.openAlertModal(
						error.general,
						this.props.t("shiftExchanges.errorManage")
					);
				},
				closeModal: this.closeModal,
			},
			"confirm"
		);
	};

	reopenOwnExchange = (exchange) => {
		this.props.showModal(
			{
				open: true,
				title: this.props.t("shiftExchanges.reopenRequest"),
				style: { width: "400px" },
				message: this.props.t("shiftExchanges.reopenRequestConfirm"),
				confirmText: this.props.t("shiftExchanges.reopenRequest"),
				confirmAction: async () => {
					const response = await planAssignmentExchangesService.update({
						...exchange,
						status: exchangeStatus.pending,
						requester_plan_id:
							exchange.requester_plan?.assignments?.[0]?.id ||
							exchange.requester_plan_id,
						target_plan_id:
							exchange.target_plan?.assignments?.[0]?.id ||
							exchange.target_plan_id,
					});

					if (response.ok) {
						this.closeModal();
						toastr.success(
							this.props.t("common.success"),
							this.props.t("common.changesSaved")
						);
						this.reloadExchanges();
						return;
					}

					const error = errorFormating(response);
					this.closeModal();
					this.openAlertModal(
						error.general,
						this.props.t("shiftExchanges.errorManage")
					);
				},
				closeModal: this.closeModal,
			},
			"confirm"
		);
	};

	openAlertModal(message, title) {
		this.props.showModal(
			{
				open: true,
				title: title || "Error",
				style: { width: "400px" },
				message,
				closeModal: this.closeModal,
			},
			"alert"
		);
	}

	getContent() {
		if (this.state.isLoading && this.state.page === 0) {
			return <Loading />;
		}

		const { hasMore, exchanges, employee_id, activeTab } = this.state;
		const selectedEmployeeId =
			Number(employee_id) > 0 ? employee_id : this.props.user?.id;
		const canEditOwnRequest =
			activeTab === "sent" &&
			Number(selectedEmployeeId) === Number(this.props.user?.id);

		return (
			<InfiniteScroll
				dataLength={exchanges.length}
				next={this.fetchMoreData}
				hasMore={hasMore}
				loader={
					<div style={{ textAlign: "center", padding: "10px" }}>Loading...</div>
				}
			>
				<ShiftExchangesList
					exchanges={exchanges}
					canEdit={canEditOwnRequest}
					showActions={
						isAdmin() || isSupervisor() || this.state.activeTab === "received"
					}
					openAlertModal={this.openAlertModal}
					openEditExchangeModal={this.openEditExchangeModal}
					cancelOwnExchange={this.cancelOwnExchange}
					reopenOwnExchange={this.reopenOwnExchange}
					reloadExchanges={this.reloadExchanges}
				/>
			</InfiniteScroll>
		);
	}

	render() {
		const canSeeAll = isAdmin() || isSupervisor();
		const selectedEmployeeId =
			Number(this.state.employee_id) > 0
				? this.state.employee_id
				: this.props.user?.id;

		return (
			<>
				<Layout
					configSidebar={false}
					className="page-absences page-shift-exchanges"
					context="shift-exchanges"
				>
					<div className="heading">
						<h1 className="title">
							{this.props.t("shiftExchanges.title")}
						</h1>

						<div className="heading-actions">
							{canSeeAll && (
								<EmployeeSelectSearch
									className="form-select-user mr10"
									controlId="employee_id"
									multiple={false}
									allowClear={false}
									value={selectedEmployeeId ? String(selectedEmployeeId) : null}
									onChange={this.handleEmployeeChange}
									fetchOptions={{ enabled: true }}
									placeholder={this.props.t("common.searchEmployee")}
									knownEmployee={
										this.state.selectedEmployee ||
										(Number(selectedEmployeeId) === Number(this.props.user?.id)
											? this.props.user
											: null)
									}
									pinnedShortcut={
										this.props.user?.id &&
										Number(selectedEmployeeId) !== Number(this.props.user.id)
											? {
													id: this.props.user?.id,
													label: this.props.t("shiftExchanges.myRequests"),
													employee: this.props.user,
												}
											: null
									}
								/>
							)}
							<DateRangePicker
								startDateId="personalShiftExchangeStartDate"
								endDateId="personalShiftExchangeEndDate"
								startDate={this.state.start_from ? moment(this.state.start_from) : null}
								endDate={this.state.start_to ? moment(this.state.start_to) : null}
								startDatePlaceholderText={this.props.t("common.from")}
								endDatePlaceholderText={this.props.t("common.to")}
								onDatesChange={this.handleDatesChange}
								focusedInput={this.state.focusedInput}
								onFocusChange={(focusedInput) => this.setState({ focusedInput })}
								hideKeyboardShortcutsPanel={true}
								isOutsideRange={() => false}
								minimumNights={0}
							/>
							<button
								type="button"
								className="btn btn-new"
								title={this.props.t("shiftExchanges.newRequest")}
								aria-label={this.props.t("shiftExchanges.newRequest")}
								onClick={this.openNewExchangeModal}
							>
								<FiPlus />
							</button>
						</div>
					</div>

					<Nav
						variant="tabs"
						className="employee-tabs"
						style={{ marginBottom: "20px", paddingLeft: "0" }}
						activeKey={this.state.activeTab}
						onSelect={this.handleTabSelect}
					>
						<Nav.Item>
							<Nav.Link eventKey="received">
								{this.props.t("shiftExchanges.receivedTab")}
							</Nav.Link>
						</Nav.Item>
						<Nav.Item>
							<Nav.Link eventKey="sent">
								{this.props.t("shiftExchanges.sentTab")}
							</Nav.Link>
						</Nav.Item>
					</Nav>
					{this.getContent()}
				</Layout>

				<Modal hideModal={this.props.hideModal} />
			</>
		);
	}
}

const mapStateToProps = (reducers) => ({ user: reducers.authReducer.user });

const mapDispatchToProps = (dispatch) => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) =>
		dispatch(showModal({ modalProps, modalType })),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withTranslation()(ShiftExchanges));
